import React from 'react';

class Tab extends React.Component {
    render () {
        if (this.props.switch === this.props.value) {
            return (
                <div {...this.props} className={['component-tab', this.props.className].join(' ')}>
                    {this.props.children}
                </div>
            )
        } else {
            return null;
        }
    }
}

export default Tab;



// WEBPACK FOOTER //
// ./web-app/components/tab.jsx